import React, { useState, useEffect } from "react";
import axios from "axios";
import { data } from "jquery";
import CommonHeader from "../Common Header/CommonHeader";

const CirriculamDetails = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    gettingData();
  }, []);

  const gettingData = async () => {
    try {
      const response = await axios.get("/curricular.php");
      if (response?.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
    }
  };

  const renderContent = (content) => {
    return content
      .split("\n")
      .map((paragraph, index) => <p key={index}>{paragraph}</p>);
  };

  if (data === null) {
    return (
      <>
        <h2>Loading......</h2>
      </>
    );
  }
  return (
    <>
      <CommonHeader heading={"Curricular"} />
      <div className="container">
        <section className="container">
          <div className="row">
            {data !== null ? (
              data.map((obj, ind) => (
                <section className="col-sm-12 maincontent" key={ind}>
                  <h3>{obj.title}</h3>
                  <p className="contentSection">
                    {obj.image_path && ( // Check if image_path exists
                      <img
                        src={`${axios.defaults.baseURL}/Images/${obj.image_path}`}
                        alt="No Image Data Found"
                        className={`img-rounded ${
                          ind % 2 === 0 ? "pull-right" : "pull-left"
                        }`}
                        width="300"
                        height={300}
                      />
                    )}
                    <div> {renderContent(obj.description)}</div>
                  </p>
                </section>
              ))
            ) : (
              <h3>Loading...</h3>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default CirriculamDetails;
